export const householdId = 'householdId';
export const clientId = 'clientId';
export const folderId = 'folderID';
export const modal = 'modal';
export const currentFile = 'currentFile';
export const files = 'files';
export const FILE_UPLOAD_TYPES = {
  secure: 'secure',
  transaction: 'transaction',
  emailAttachment: 'emailAttachment',
  messageAttachment: 'messageAttachment',
};

// Questionnaire sections
export const section = 'section';

export const ACCOUNT_MANAGEMENT_DEFAULT = 'default';
export const ACCOUNT_MANAGEMENT_ADD_ACCOUNT = 'addAccount';
export const ACCOUNT_MANAGEMENT_OPEN_MANAGED_ACCOUNT = 'openManagedAccount';
export const ACCOUNT_MANAGEMENT_EDIT = 'edit';


export const goalId = 'goalId';
export const createNewGoal = 'createNewGoal';
export const goalType = 'goalType';

export const dockedItems = 'dockedItems';

export const displayBestPractices = 'displayBestPractices';

export const tab = 'tab';

// utm query vals
export const UTM_SOURCE = 'utm_source';
export const UTM_SOURCE_EMAIL = 'email';
